import pluralize from 'pluralize';

import { getAccountCardElementsConfiguration } from '../../../../../../services/cards/components/AccountCard/helpers';
import { CARD_ELEMENT_TYPE } from '../../../../../../services/cards/constants';

/**
 * Extracts the first name out of a full name string.
 *
 * @param {string} name The full name.
 * @returns {string}
 */
export const getRecipientFirstName = name =>
  name?.split(' ').map(s => s.trim())[0] || '';

/**
 * Returns a pretty string for global Waldogram recipient names.
 *
 * @param {Array<Object>} recipients The Waldogram recipients (RosterIdentityLinkedAddresses or ExternalShippingAddresses).
 * @returns {string}
 */
export const getGlobalWaldogramSuccessCopy = recipients => {
  if (recipients.length === 1) {
    const [recipient] = recipients;

    return getRecipientFirstName(recipient.name);
  }

  const [first, second, ...rest] = recipients;

  if (rest.length > 0) {
    return `${getRecipientFirstName(first.name)}, ${getRecipientFirstName(
      second.name,
    )}, and ${rest.length} ${pluralize('other', rest.length)}`;
  }

  return `${getRecipientFirstName(first.name)} and ${getRecipientFirstName(
    second.name,
  )}`;
};

/**
 * Gets recipients from an AccountCard (ExternalShippingAddresses or RosterIdentityAddresses).
 *
 * @param {Object} accountCard The AccountCard.
 * @returns {*[]|*}
 */
export const getFinalRecipientsFromAccountCard = accountCard => {
  if (!accountCard) {
    return [];
  }

  const elements = getAccountCardElementsConfiguration(accountCard);
  const addressElement = elements.find(element => {
    const { cardElement } = element;
    return cardElement.type === CARD_ELEMENT_TYPE.ADDRESS;
  });
  const { cardElementConfiguration } = addressElement;
  const rosterIdentityAddresses =
    cardElementConfiguration.roster_identity_linked_identity_addresses
      ?.records ?? [];
  const externalShippingAddresses =
    cardElementConfiguration.external_shipping_addresses?.records ?? [];

  return externalShippingAddresses?.length > 0
    ? externalShippingAddresses
    : rosterIdentityAddresses;
};
